import React from 'react';
import { StickyBar } from 'seduo-ui';
const image = (<img src="https://dummyimage.com/130x50/9fa4a8/fff.png" width="130" height="50" alt="ALBI Česká republika a.s." className="img-fluid"/>);
const Example = () => <StickyBar text="Neomezený přístup ke všem kurzům máte od svého zaměstnavatele" image={image}/>;
export default Example;
